export default "__VITE_ASSET__Bf2xy9wm__"